// @flow

import React, {Component} from 'react';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import $ from 'jquery';
import {saveAs} from 'file-saver';
import * as ExcelJs from 'exceljs/dist/es5/exceljs.browser';

import Toolbar from './Toolbar.jsx';

import {setHeaderExcel, setTitlesStyles} from './imgExcel.js';
import show_stats from './show_stats.js';
import {no_rclick, takeDir, gen_snum, title_culti} from './utils.js';

import type {T_StatRow} from './Stats.jsx';


type T_MenuStatsProps = {
  culti        : string,
  cond         : boolean,
  agrosat_user : boolean,
  showing_stats: boolean,
  toolbar      : Toolbar
};



export default class MenuStats extends Component<T_MenuStatsProps> {
  close           : () => void;
  make_excel_stats: () => void;
  change_item     : (ev: SyntheticMouseEvent<*>, value: string) => void;
  
  
  
  constructor(props: T_MenuStatsProps) {
    super(props);
    
    this.close            = this.close.bind(this);
    this.change_item      = this.change_item.bind(this);
    this.make_excel_stats = this.make_excel_stats.bind(this);
  }
  
  
  
  close(): void {
    this.props.toolbar.setState({show_menu_stats: false});
  }
  
  
  
  make_excel_stats(): void {
    const {app}     = this.props.toolbar.props,
          dir       = takeDir(this.props.culti),
          pngs      = app.get_images_of(dir),
          snum      = gen_snum(app.state.num_decimals),
          all_stats = [],
          {toolbar} = this.props,
          {culti}   = toolbar.all_stats[0],
          total_has = _.has(app.map_ui.map.Shp_List, culti) ? app.map_ui.map.Shp_List[culti].obj.total_has : 0;
    
    pngs.forEach((png) => {
      const stat = toolbar.all_stats.find(st => st.png === png.props.node.File);
      
      if (stat != null) {
        const rows = stat.rows.map((row: T_StatRow) => {
          return {
            ID      : row.ID,
            Nombre  : row.Nombre,
            Has     : snum(row.Has),
            Min     : snum(row.Min),
            Max     : snum(row.Max),
            Promedio: snum(row.Promedio),
            CV      : snum(row.CV)
          };
        });
        
        rows.push({
          ID      : '',
          Nombre  : 'Total',
          Has     : snum(total_has || 0),
          Min     : snum(stat.total.Min),
          Max     : snum(stat.total.Max),
          Promedio: snum(stat.total.Promedio),
          CV      : snum(stat.total.CV)
        });
        
        all_stats.push({elem: stat.elem, rows, units: stat.units});
      }
    });
    
    const title    = title_culti(culti),
          workbook = new ExcelJs.Workbook();
    
    const setContentStyleOther = (worksheet, aux) => {
      worksheet.eachRow((row, rowNumber) => {
        let mm = 4;
        
        worksheet.getRow(rowNumber).eachCell((cell, rowNumberC) => {
          if (rowNumber === 5 || rowNumber === 6) {
            if (cell._column._number === mm) {
              cell.border = {
                left  : {style: 'thin', color: {argb: 'FF2A2A2A'}},
                bottom: {style: 'thin', color: {argb: 'FF2A2A2A'}},
              };
              mm += aux;
            }
          }
          else if (rowNumber > 6) {
            if (cell._column._number === 1) {
              cell.alignment = {vertical: 'middle', horizontal: 'center'};
            }
            else if (cell._column._number === 2) {
              if (rowNumber === all_stats[0].rows.length + 6) {
                cell.font = {bold: true};
                cell.alignment = {vertical: 'middle', horizontal: 'right'};
              }
              else {
                cell.alignment = {vertical: 'middle', horizontal: 'left'};
              }
            }
            else if (cell._column._number > 2) {
              cell.alignment = {vertical: 'middle', horizontal: 'right'};

              if (cell._column._number === mm) {
                cell.border = {
                  left: {style: 'double', color: {argb: 'FF0000'}},    // FIXME: si es argb, el color debe tener 8 chars.
                };
                
                mm += aux;
              }
            }
          }
        });
      });
    };
    
    const setElementos = () => {
      const style = {alignment: {vertical: 'middle'}};
      
      all_stats.forEach((sts, ii) => {
        const worksheet = workbook.addWorksheet(sts.elem),
              subtitle = sts.elem + (sts.units ? ` ${sts.units}` : '');
        
        setHeaderExcel(workbook, worksheet, title, subtitle, 'STATS');
        
        worksheet.columns = [
            {key: 'id'      , style, width: 15},
            {key: 'nombre'  , style, width: 15},
            {key: 'has'     , style, width: 15},
            {key: 'min'     , style, width: 15},
            {key: 'max'     , style, width: 15},
            {key: 'promedio', style, width: 15},
            {key: 'cv'      , style, width: 15}
        ];
        
        worksheet.addRow({
          id      : 'ID',
          nombre  : 'Nombre',
          has     : 'Has.',
          min     : 'Min',
          max     : 'Max',
          promedio: 'Promedio',
          cv      : 'CV'
        });
        
        setTitlesStyles(worksheet, 5, false);
        
        sts.rows.forEach((st, kk) => {
          worksheet.addRow({
            id      : st.ID,
            nombre  : st.Nombre,
            has     : st.Has,
            min     : st.Min,
            max     : st.Max,
            promedio: st.Promedio,
            cv      : st.CV
          });
          
          if (kk < sts.rows.length) {
            worksheet.getRow(kk + 6).height = 25;
            
            worksheet.getRow(kk + 6).eachCell((cell, rowNumber) => {
              const even = cell._row._number % 2 === 0;
              
              cell.alignment = {
                vertical  : 'middle',
                horizontal: (cell._column._number === 1 ? 'center' : 'right')
              };
              
              cell.fill = {
                type   : 'pattern',
                pattern: 'solid',
                fgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')},
                bgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')}
              };
            });
          }
        });
        
        worksheet.getRow(sts.rows.length + 5).getCell(2).font = {bold: true};
        
        worksheet.getRow(sts.rows.length + 5).eachCell((cell, rowNumber) => {
          cell.alignment = {vertical: 'middle', horizontal: 'right'};
        });
      });
      
      setTodos();
    };
    
    const setTodos = () => {
      const worksheet = workbook.addWorksheet('Todos');
      
      setHeaderExcel(workbook, worksheet, title, 'Todos', 'STATS');
      
      const todosTitles = [[], ['ID', 'Nombre', 'Has.']],
            todosValues = [];
      
      // valores comunes ID, nombre Has
      
      all_stats[0].rows.forEach((st, kk) => {
        todosValues[kk] = [st.ID, st.Nombre, st.Has];
      });
      
      // valores restantes
      
      all_stats.forEach((sts, ks) => {
        todosTitles[0].push('', '', '', sts.elem);
        todosTitles[1].push('Min', 'Max', 'Promedio', 'CV');
        
        sts.rows.forEach((st, kk) => {
          todosValues[kk].push(st.Min, st.Max, st.Promedio, st.CV);
        });
      });
      
      worksheet.addRows(todosTitles);
      
      setTitlesStyles(worksheet, 5, false);
      setTitlesStyles(worksheet, 6, true);
      
      worksheet.addRows(todosValues);
      
      setContentStyleOther(worksheet, 4);
      
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 6) {
          row.height = 25;
          
          row.eachCell((cell, rowNumber) => {
            const even = cell._row._number % 2 === 0;
            
            cell.fill = {
              type   : 'pattern',
              pattern: 'solid',
              fgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')},
              bgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')}
            };
          });
        }
      });
      
      setTodosReagrupados();
    };
    
    const setTodosReagrupados = () => {
      const worksheet = workbook.addWorksheet('Todos Reagrupados');
      
      setHeaderExcel(workbook, worksheet, title, 'Todos Reagrupados', 'STATS');
      
      const todosTitles = [[], []],
            todosValues = [],
            todosProm   = [],
            todosMin    = [],
            todosMax    = [],
            todosCV     = [],
            elems       = [];
      
      const comun = ['Promedio', 'Min', 'Max', 'CV'];
      
      // valores comunes ID, nombre Has
      
      all_stats[0].rows.forEach((sts, kk) => {
        todosProm[kk]   = [];
        todosMin[kk]    = [];
        todosMax[kk]    = [];
        todosCV[kk]     = [];
        todosValues[kk] = [sts.ID, sts.Nombre, sts.Has];
      });
      
      // valores restantes
      
      all_stats.forEach((sts, ks) => {
        sts.rows.forEach((st, ki) => {
          if (ki === 0) {
            elems.push(sts.elem);
          }
          
          todosProm[ki].push(st.Promedio);
          todosMin[ki].push(st.Min);
          todosMax[ki].push(st.Max);
          todosCV[ki].push(st.CV);
        });
      });
      
      todosValues.forEach((cc, ko) => {
        todosValues[ko] = todosValues[ko].concat(todosProm[ko], todosMin[ko], todosMax[ko], todosCV[ko]);
        todosTitles[1] = todosTitles[1].concat(elems);
        todosTitles[0] = todosTitles[0].concat(comun[ko]);
        
        all_stats.forEach((sts, kn) => {
          if (kn > 0) {
            todosTitles[0].push('');
          }
        });
      });
      
      todosTitles[0] = ['', '', ''].concat(_.take(todosTitles[0], 4 * all_stats.length));
      todosTitles[1] = ['ID', 'Nombre', 'Has.'].concat(_.take(todosTitles[1], 4 * all_stats.length));
      
      worksheet.addRows(todosTitles);
      
      setTitlesStyles(worksheet, 5, false);
      setTitlesStyles(worksheet, 6, true);
      
      worksheet.addRows(todosValues);
      
      setContentStyleOther(worksheet, all_stats.length);
      
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 6) {
          row.height = 25;
          
          row.eachCell((cell, rowNumber) => {
            const even = cell._row._number % 2 === 0;
            
            cell.fill = {
              type   : 'pattern',
              pattern: 'solid',
              fgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')},
              bgColor: {argb: (even ? 'FFDEDEDE' : 'FFEFEFEF')}
            };
          });
        }
      });
    };
    
    setElementos();
    
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer],{type:"application/octet-stream"}), `Estadisticas_${title.replace(/ /g, '_')}.xls`);
    });
  }
  
  
  
  change_item(ev: SyntheticMouseEvent<*>, value: string): void {
    if (ev.button !== 0) {
      return;
    }
    
    const {toolbar} = this.props,
          {app}     = toolbar.props;
    
    if (value === 'show') {
      toolbar.toggle_stats();
    }
    else if (value === 'recalc') {
      toolbar.setState({stats: null, stats_recalc: true}, () => {
        show_stats(app, this.props.culti, toolbar.stats_diagnostics, true);
      });
    }
    else if (value === 'download') {
      if (toolbar.state.stats != null) {
        toolbar.setState({show_menu_stats: false, stats: null}, () => {
          show_stats(app, this.props.culti, this.make_excel_stats, false, true);
        });
      }
      else {
        show_stats(app, this.props.culti, this.make_excel_stats, false, true);
      }
    }
  }
  
  
  
  render() {
    if (_.has(this.props, 'cond') && ! this.props.cond)
      return null;
    
    const m_style = {fontSize: 13, lineHeight: '30px'},
          left = {style: {left: $('#bt_stats').position().left + 6}};
    
    return (
      <Paper className='float_menu' {...left}>
        <Menu onChange={this.change_item} desktop={true} style={{maxWidth: 220}}>
          <MenuItem
            style={m_style}
            value='show'
            primaryText={this.props.showing_stats ? 'Ocultar' : 'Mostrar'}
            onContextMenu={no_rclick}
          />
          
          {this.props.agrosat_user &&
            <MenuItem
              style={m_style}
              value='recalc'
              primaryText='Recalcular'
              onContextMenu={no_rclick}
            />
          }
          
          <MenuItem
            style={m_style}
            value='download'
            primaryText='Descargar'
            onContextMenu={no_rclick}
          />
        </Menu>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MenuStats.jsx